module.exports = __webpack_public_path__ + "assets/img/btn-detail-ba1f7e70.png";